module.exports = __webpack_public_path__ + "static/media/hcia_routing_switching.9cb97846.png";